import { formatDate, getIsoDate } from '../../utils';
import { serializeSort } from './default';
import { FilterTransformer, SortSerializer } from './types';

export const serializeValidPeriod = ((id, value) =>
  id !== 'validPeriod'
    ? { [id]: value }
    : {
        validFrom: value?.[0] && getIsoDate(value[0]),
        validTo: value?.[1] && getIsoDate(value[1]),
      }) satisfies FilterTransformer;

export const deserializeValidPeriod = ((id, value, allQueryFilters) =>
  id === 'validFrom'
    ? { validPeriod: [formatDate(value), formatDate(allQueryFilters.validTo)] }
    : {
        [id]: id === 'validTo' ? undefined : value,
      }) satisfies FilterTransformer;

export const serializeValidPeriodSort = (({ id, desc }) =>
  id === 'validPeriod'
    ? [
        serializeSort({ id: 'validFrom', desc }),
        serializeSort({ id: 'validTo', desc }),
      ]
    : serializeSort({ id, desc })) satisfies SortSerializer<any>;
